<template>
    <div id="about">
        <section class="hero is-fullheight fitco lecture">
            <div class="hero-head">
                <navigation></navigation>
            </div>
            <div class="hero-body">
                <div class="container has-text-centered">
                    <p class="title is-1 has-text-white">"My biggest moment is seeing you experience <span class="fitco-underline">your biggest moment</span>!"</p>
                    <p class="subtitle is-6 has-text-white">- <em>Stacy Wig, Founder of FitCo Wellness</em></p>
                </div>
            </div>
            <div class="hero-foot">
                <div class="container has-text-centered">
                    <span class="down"></span>
                </div>
            </div>
        </section>
        <section class="hero is-white is-large">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-variable is-8">
                        <div class="column">
                            <h1 class="is-title has-text-dark">Our driving force 💪</h1>
                            <br>
                            <p class="is-subtitle has-text-dark">Our inspiration comes from being a part of the company and employee transformation. The company culture becomes centered around overall wellness, employees embrace healthy competition, and by improving your bottom line by saving time and money. We're constantly evaluating our programs to ensure that our clients experience the very best coaching that produces results!</p>
                            <br>
                            <p class="is-subtitle has-text-dark">We believe <strong>everyone</strong> deserves to feel empowered, confident, and strong.</p>
                            <br>    
                        </div>
                        <div class="column">
                            <figure class="image is-4by3">
                                <img style="margin: auto;" src="@/assets/image/group.jpg">
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="hero is-white">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-variable is-8">
                        <div class="column">
                            <figure class="image is-3by4">
                                <img style="margin: auto;" src="@/assets/image/phonecall.png">
                            </figure>
                        </div>
                        <div class="column">
                            <h1 class="is-title has-text-dark">Our program 🏋️‍♀️</h1>
                            <br>
                            <p class="is-subtitle has-text-dark">Our entire program is virtual and can be done from anywhere in the world. Each week, your teams will become part of a wellness platform where they can access weekly workouts, yoga and meditation classes, ergonomic guidance during the workday, nutrition tips, team challenges, lunch and learns each Wednesday, and so much more.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="hero is-white is-medium">
            <div class="hero-body">
                <div class="container">
                    <h1 class="is-title has-text-dark">Anytime, Anywhere.</h1>
                    <br>
                    <p class="is-subtitle has-text-dark">We know that everyone has a busy schedule. That's why all of our live classes are recorded and are available on-demand.</p>    
                </div>  
            </div>
        </section>
        <section class="hero is-primary is-medium">
            <div class="hero-body">
                <div class="container">
                    <div class="columns">
                        <div class="column">
                            <h1 class="title is-1 has-text-dark">Got a burning question? We're here to talk.</h1>
                            <h2 class="subtitle is-3 has-text-dark">Find out how we can improve your bottom line!</h2>
                            <br>
                            <router-link to="/contact" class="button is-large is-dark is-outlined thick is-rounded" style="font-weight: 700;">Schedule a Demo</router-link>
                        </div>
                        <div class="column">

                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import navigation from '@/components/navigation.vue'

export default {
    components: {navigation}
}
</script>